import { render } from "./DashboardFilterChips.vue?vue&type=template&id=4b3fffb2&ts=true"
import script from "./DashboardFilterChips.vue?vue&type=script&lang=ts"
export * from "./DashboardFilterChips.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__